/**
 * Scenario identifiers used to track feedback timestamps in user settings.
 * These are internal keys — they are never displayed to users and must not change
 * once in production (changing them would reset feedback cooldown tracking for all users).
 */
export const ASSIGN_OPEN_SHIFTS_FEEDBACK_SCENARIO_SUCCESS = "assignOpenShiftsSuccess";
export const ASSIGN_OPEN_SHIFTS_FEEDBACK_SCENARIO_CANCEL = "assignOpenShiftsCancel";
